import React from 'react'
import PropTypes from 'prop-types'
import { parseHTMLString } from 'utils/utility-functions'
import * as cs from 'common/common-styles';

function ParcelLookup(props) {
    const { parcelLookupLinkHtml, parcelLookupWebsite, parcelLookupLinkText } = props;
    if (parcelLookupLinkHtml) return parseHTMLString(parcelLookupLinkHtml)

    if (parcelLookupWebsite || parcelLookupLinkText)
        return (<cs.Link href={parcelLookupWebsite} target="_blank" rel="noreferrer">
            {parcelLookupLinkText}
        </cs.Link>)

    return null;
}

ParcelLookup.propTypes = {
    parcelLookupWebsite: PropTypes.string,
    parcelLookupLinkText: PropTypes.string,
    parcelLookupLinkHtml: PropTypes.string,
}

export default ParcelLookup